<template>
  <div class="flex gap-1">
    <UButton
      icon="i-heroicons-squares-2x2"
      :color="view === 'grid' ? 'primary' : 'neutral'"
      :variant="view === 'grid' ? 'solid' : 'ghost'"
      aria-label="Grid view"
      @click="$emit('update:view', 'grid')"
      class="cursor-pointer"
    />
    <UButton
      icon="i-heroicons-bars-3"
      :color="view === 'list' ? 'primary' : 'neutral'"
      :variant="view === 'list' ? 'solid' : 'ghost'"
      aria-label="List view"
      @click="$emit('update:view', 'list')"
      class="cursor-pointer"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  view: 'grid' | 'list'
}>()

defineEmits<{
  (e: 'update:view', v: 'grid' | 'list'): void
}>()
</script>
